import React from 'react';
import './WordDetail.css'


export default class WordDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            srcString: '#/press/renjiao?_k=isyr6f'
        }
    };

    render() {
        let {srcString} = this.state

        return (<div>
            <div>
                <div className="panel_iframe" style={{
                    width: '100%',
                    height: '100%',
                    border: '0',
                    background: '#fff',
                    WebkitOverflowScrolling: 'touch',
                    overflowY: 'scroll'
                }}>
                    <iframe src={srcString}/>
                </div>
            </div>
        </div>)
    }
}



// WEBPACK FOOTER //
// ./src/components/word_detail/TongBuShuFa.js